/**
 * Service: organizationsApi
 */
angular.module('acme.common.service.organizationsApi', [
  'acme.common.factory.apiVersion',
  'acme.common.factory.QueryStringBuilder'
])
.service('OrganizationsApiService', ['$http', 'ApiVersionFactory', 'QueryStringBuilderFactory', function($http, ApiVersionFactory, QueryStringBuilderFactory) {

    return {

      service: '',

      init: function(endpoint) {
        this.service = endpoint + '/organization';
        this.addresses.service = this.service;
        this.contacts.service = this.service;
        this.membership.endpoint = endpoint;
        this.membership.service = endpoint + '/membership/corporate/organizations';

        return true;
      },

      search: function(props) {
        var qs,
            q = '',
            av = new ApiVersionFactory();

        if (props) {
          qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['search', 'page', 'pageSize', 'sortDirection', 'sortField', 'totalItems']
            }
          });
          q = qs.query;
        }

        if (q.indexOf('search=') < 0) {
          q += '&search=';
        }

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/names' + q, version: 'v2' })
        });
      },

      searchOrganizations: function(props) {
        var q = '',
            av = new ApiVersionFactory();

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['status', 'page', 'pageSize', 'sortDirection', 'sortField', 'search', 'type', 'category', 'organizationName', 'contactName']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/search' + q, version: 'v2' })
        });
      },

      //list only organizations that have a category
      listTransactable: function(props) {
        var qs,
          q = '',
          av = new ApiVersionFactory();

        if (props) {
          qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              requires: ['pageSize', 'search'],
              optional: ['page', 'sortDirection', 'sortField']
            }
          });
          q = qs.query;
        }

        if (q.indexOf('search=') < 0) {
          q += '&search=';
        }

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/transactable' + q, version: 'v2' })
        });
      },

      list: function(props) {
        var qs,
          q = '',
          av = new ApiVersionFactory();

        if (props) {
          qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['search', 'page', 'pageSize', 'sortDirection', 'sortField', 'withAddress']
            }
          });
          q = qs.query;
        }

        if (q.indexOf('search=') < 0) {
          q += '&search=';
        }

        return $http({
          method: 'get',
          url: av.init({ url: this.service + q, version: 'v2' })
        });
      },

      addresses: {

        service: '',

        list: function(props) {
          var qs,
              q = '',
              av = new ApiVersionFactory();

          if (props) {
            qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['type', 'admissionType', 'pageSize', 'page', 'sortField', 'sortDirection', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: av.init({ url: this.service + '/' + props.organizationId + '/address' + q, version: 'v2' })
          });
        },

        create: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'post',
            url: av.init({ url: this.service+ '/' + props.organizationId + '/address', version: 'v2' }),
            data: {
              country: props.address.country,
              streetAddress1: props.address.streetAddress1,
              streetAddress2: props.address.streetAddress2,
              city: props.address.city,
              state: props.address.state,
              zipCode: props.address.zipCode,
              type: props.address.type,
              isPrimary: (props.hasOwnProperty('isPrimary')) ? props.isPrimary : props.address.isPrimary
            }
          });
        },

        update: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'put',
            url: av.init({ url: this.service + '/' + props.organizationId + '/address', version: 'v2' }),
            data: {
              id: props.address.id,
              country: props.address.country,
              streetAddress1: props.address.streetAddress1,
              streetAddress2: props.address.streetAddress2,
              city: props.address.city,
              state: props.address.state,
              zipCode: props.address.zipCode,
              type: props.address.type,
              isPrimary: (props.hasOwnProperty('isPrimary')) ? props.isPrimary : props.address.isPrimary
            }
          });
        },

        remove: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'delete',
            url: av.init({ url: this.service + '/' + props.organizationId + '/address/' + props.id, version: 'v2' })
          });
        },

        detail: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'get',
            url: av.init({ url: this.service + '/' + props.organizationId + '/address/' + props.id, version: 'v2' })
          });
        },

        primary: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'get',
            url: av.init({ url: this.service + '/' + props.organizationId + '/address/primary', version: 'v2' })
          });
        }
      },

      contacts: {

        service: '',

        list: function (props) {
          var qs,
              q = '',
              av = new ApiVersionFactory();

          if (props) {
            qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: av.init({
              url: this.service + '/' + props.organizationId + '/contact' + q,
              version: 'v2'
            })
          });
        },

        detail: function (props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'get',
            url: av.init({
              url: this.service + '/' + props.organizationId + '/contact/' + props.contactId,
              version: 'v2'
            })
          });
        },

        create: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'post',
            url: av.init({ url: this.service+ '/' + props.organizationId + '/contact', version: 'v2' }),
            data: {
              addressId: props.addressId,
              accountId: props.organizationId,
              organizationId: props.organizationId,
              firstName: props.firstName,
              lastName: props.lastName,
              email: props.email,
              phoneNumber: props.phoneNumber,
              country: props.country,
              streetAddress1: props.streetAddress1,
              streetAddress2: props.streetAddress2,
              city: props.city,
              state: props.state,
              zipCode: props.zipCode,
              type: props.type,
              primary: props.primary,
              isPrimary: props.isPrimary
            }
          });
        },

        update: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'put',
            url: av.init({ url: this.service+ '/' + props.organizationId + '/contact', version: 'v2' }),
            data: {
              id: props.id,
              addressId: props.addressId,
              accountId: props.organizationId,
              organizationId: props.organizationId,
              firstName: props.firstName,
              lastName: props.lastName,
              email: props.email,
              phoneNumber: props.phoneNumber,
              country: props.country,
              streetAddress1: props.streetAddress1,
              streetAddress2: props.streetAddress2,
              city: props.city,
              state: props.state,
              zipCode: props.zipCode,
              type: props.type,
              primary: props.primary,
              isPrimary: props.isPrimary
            }
          });
        },

        remove: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'delete',
            url: av.init({ url: this.service+ '/' + props.organizationId + '/contact/' + props.contactId, version: 'v2' })
          });
        },

        primary: function (props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'get',
            url: av.init({url: this.service + '/' + props.organizationId + '/contact/primary', version: 'v2'})
          });
        }
      },

      membership: {

        endpoint: '',
        service: '',

        list: function(props) {

          var q = '',
              av = new ApiVersionFactory();

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: av.init({ url: this.service + '/' + props.id + q, version: 'v2' })
          });

        },

        cardholders: function(props) {

          var q = '',
              av = new ApiVersionFactory();

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: av.init({ url: this.service + '/' + props.id + '/cards' + q, version: 'v2' })
          });

        },


        detail: function(props) {

          var av = new ApiVersionFactory();

          return $http({
            method: 'get',
            url: av.init({ url: this.service + '/' + props.id, version: 'v2' })
          });

        },

        attributes: function(props) {
          var av = new ApiVersionFactory();

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: av.init({ url: this.endpoint + '/organization/integration/' + props.id + '/attributes' + q, version: 'v2' })
          });
        },

        create: function(props) {

          var av = new ApiVersionFactory();

          return $http({
            method: 'post',
            url: av.init({ url: this.service, version: 'v2' }),
            data: {
              // TODO: Populate
            }
          });

        },

        update: function(props) {

          var av = new ApiVersionFactory();

          return $http({
            method: 'put',
            url: av.init({ url: this.service, version: 'v2' }),
            data: {
              id: props.id
            }
          });

        },

        remove: function(props) {

          var av = new ApiVersionFactory();

          return $http({
            method: 'delete',
            url: av.init({ url: this.service + '/' + props.id, version: 'v2' })
          });

        }

      }

    };

}]);